import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IpoTranslatePipe } from '@ip-only/front-end-library';
import { ProgressEntity } from '../../types/services-progress-entities';
import { provideTranslations } from '../../utils/translations-util';
import translationEn from './progress-bar.en.json';
import translationFi from './progress-bar.fi.json';
import translationSv from './progress-bar.sv.json';

@Component({
  selector: 'app-progress-bar',
  imports: [CommonModule, IpoTranslatePipe],
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
  providers: [
    provideTranslations({
      sv: {
        ...translationSv,
      },
      en: {
        ...translationEn,
      },
      fi: {
        ...translationFi,
      },
    }),
  ],
})
export class ProgressBarComponent {
  @Input() activeStep: ProgressEntity;
  @Input() steps: ProgressEntity[];
}
